import React, { Component } from 'react';

class RubroTag extends Component {
    constructor(props) {
        super(props);
        this.changeRubro = this.changeRubro.bind(this);
    }

    changeRubro(descripcion) {
        this.props.changeRubro(descripcion, false);
    }

    render () {
        return (
            <li className="inlineListItem right-separator-xxs">
                <div className="btn-group">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{this.props.Descripcion}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.changeRubro(this.props.Descripcion)}>
                        <span className="ti-close span-closable color-white" title="Quitar este permiso." key={this.props.key}></span>
                    </button>
                </div>
            </li>
        );
    }
};

export default RubroTag;